import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from 'react-router'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useCurrentDocument() {
  const documentKey = useParams<'documentKey'>().documentKey as string

  return useSuspenseQuery({
    ...apiClient.getDocumentDocumentsKeyGetOptions({
      path: {
        key: documentKey,
      },
    }),
    staleTime: 1000 * 60,
  })
}
